module.exports = __webpack_public_path__ + "img/level10.2d9dc6bf.png";